import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar,{attrs:{"color":"yellow darken-2","dense":"","flat":""}},[_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.goBack()}}},[_c(VIcon,{attrs:{"color":"black"}},[_vm._v("mdi-arrow-left")])],1),_c('p',{staticClass:"body-1 mb-0 black--text"},[_vm._v(_vm._s(_vm.title))]),_c(VSpacer),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }